import { useQuery } from "@tanstack/react-query";
import { GET_DESTINATION_COUNTRIES } from "@/constants/Query";
import { IDestinationCountries } from "@/types/apiResponse.types";
import { apiRequestSendGe } from "@/utils/apiRequestSendGe";

export const useGetDestinationCountriesRequest = () => {
  return useQuery<{
    data: {
      data: IDestinationCountries[];
    };
  }>({
    queryKey: [GET_DESTINATION_COUNTRIES],
    queryFn: () => apiRequestSendGe(GET_DESTINATION_COUNTRIES, "get"),
  });
};
